<div>Change current series</div>
<mat-form-field appearance="fill">
  <mat-label>Current series</mat-label>
  <mat-select [formControl]="series">
    @for (s of seriesOptions; track s) {
      <mat-option [value]="s.id">{{s.name}}</mat-option>
    }
  </mat-select>
</mat-form-field>
<button mat-raised-button color="primary" style="margin-left: 8px;" (click)="submit()">Save</button>
